import axios from 'axios'
import store from '@/store'
import { TOKEN_REFRESH } from '@/store/actions/auth'

const api = ({ url, data, method = 'GET'} ) => {
	
	let token = store.getters.authToken;
	let headers = {}
	let tokenNeedsRefresh = false

	if (token) {
		
		headers.Authorization = token
		let expirey = parseInt(localStorage.getItem("idExpires"));
		let currentTime = Date.now()/1000
		expirey = expirey - (60 * 2);
		if(currentTime > expirey){
			console.log("REFRESH TOKEN")
			tokenNeedsRefresh = true;

		}

	} else {
		headers.Authorization = null
	}

	return new Promise((resolve, reject) => {

		if(tokenNeedsRefresh){

			store.dispatch(TOKEN_REFRESH).then(() => {
				headers.Authorization = store.getters['authToken']
				performRequest()
			});

		}else{

			performRequest()

		}

		function performRequest(){
			axios({
				method,
				data,
				headers,
				url: `https://fqwrgdp5j1.execute-api.eu-west-2.amazonaws.com/prod/${url}`
			}).then(response => {
	
				resolve(response)
	
			}).catch(error => {
				
				reject(error)
	
			});
		}

	})

}


export default api
  